export default "__VITE_ASSET__CUlTrl7t__";